import classes from './EmbedCard.module.scss';

export default function EmbedCard({ children, isActionable = false }) {
  return <div className={!isActionable && classes.cardContainer}>{children}</div>;
}
